// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-26c5d13b] .tab-content .el-tabs__header{margin-bottom:20px !important}[data-v-26c5d13b] .dialog-footer-inner{float:left !important}[data-v-26c5d13b] .closeBtn{display:none}[data-v-26c5d13b] .el-tabs__nav .el-tabs__item:nth-of-type(1){padding-left:20px !important}", ""]);
// Exports
module.exports = exports;
